import { elegir } from '../ui/layout-variant.tsx';
import { BienvenidaMobile } from './Bienvenida.mobile.tsx';
import { BienvenidaDesktop } from './Bienvenida.desktop.tsx';

export interface PropsBienvenida {
  alTerminar: () => void;
  /** El onboarding no puede ser un callejón: siempre hay cómo salir de la cuenta desde acá. */
  onSalir: () => Promise<void>;
}

export default elegir<PropsBienvenida>(BienvenidaMobile, BienvenidaDesktop);
